<div
  class="command-bar-overlay"
  *ngIf="isOpen$ | async"
  (click)="customCommandBarService.close()"
>
  <div class="command-bar-modal" (click)="$event.stopPropagation()">
    <div class="search-container">
      <ion-icon name="search-outline" class="search-icon"></ion-icon>
      <input
        #searchInput
        type="text"
        placeholder="Type a command or search..."
        [value]="searchTerm"
        (input)="onSearchTermChange($event)"
        (keydown.enter)="onEnter($event)"
        class="search-input"
      />
    </div>
    <div class="actions-list-container">
      <ion-list *ngIf="filteredActions.length > 0; else noResults">
        <ion-item
          *ngFor="let action of filteredActions; let i = index"
          [class.active]="i === activeIndex"
          (click)="selectAction(action)"
          [id]="'action-item-' + i"
          class="action-item ion-item-rounded"
          lines="none"
          button="true"
        >
          <ion-icon
            [name]="action.icon || 'flash-outline'"
            slot="start"
            class="action-icon"
          ></ion-icon>
          <ion-label class="action-name">{{ action.name }}</ion-label>
          <ion-text
            slot="end"
            class="action-shortcut"
            *ngIf="action.shortcut"
            >{{ formatShortcut(action.shortcut) }}</ion-text
          >
        </ion-item>
      </ion-list>
      <ng-template #noResults>
        <div class="no-results">
          <p>No results found</p>
        </div>
      </ng-template>
    </div>

    <!-- <div class="command-bar-footer">
       Powered by your custom command bar
    </div> -->
  </div>
</div>
